import { Flex, Typography, DatePicker } from "antd";
import dayjs from "dayjs";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { DocstoreSections } from "../../../../../../model";
import { DocstoreUploadForm, FieldConfig } from "../../model/types";

interface IModalDatePicker {
  selectedSection: (typeof DocstoreSections)[keyof typeof DocstoreSections];
  fieldConfig: FieldConfig;
  control: Control<DocstoreUploadForm>;
}

export function ModalDatePicker({
  selectedSection,
  fieldConfig,
  control,
}: IModalDatePicker) {
  return (
    <Flex
      vertical={
        selectedSection !== DocstoreSections.CERTIFICATE
      }
      gap="24px"
    >
      <Flex
        vertical
        gap="4px"
        style={{
          width: `${
            selectedSection === DocstoreSections.CERTIFICATE
              ? "100%"
              : ""
          }`,
        }}
      >
        <Typography.Text>{fieldConfig.title}</Typography.Text>
        <FormItem<DocstoreUploadForm>
          name={fieldConfig.name as keyof DocstoreUploadForm}
          control={control}
          getValueProps={(value) => ({
            value: value ? dayjs(value) : null,
          })}
          normalize={(date) => (date ? date.toDate() : null)}
          style={{ marginBottom: 0 }}
        >
          <DatePicker
            format="DD.MM.YYYY"
            style={{
              width:
                selectedSection === DocstoreSections.CERTIFICATE
                  ? "100%"
                  : "30%",
            }}
          />
        </FormItem>
      </Flex>
      {selectedSection === DocstoreSections.CERTIFICATE && (
        <Flex vertical gap="4px" style={{ width: "100%" }}>
          <Typography.Text>Дата окончания срока</Typography.Text>
          <FormItem<DocstoreUploadForm>
            name="endDate"
            control={control}
            getValueProps={(value) => ({
              value: value ? dayjs(value) : null,
            })}
            normalize={(date) => (date ? date.toDate() : null)}
            style={{ marginBottom: 0 }}
          >
            <DatePicker format="DD.MM.YYYY" />
          </FormItem>
        </Flex>
      )}
    </Flex>
  );
}
